import React, { useRef } from "react";
import Slider from "react-slick";
import { I18n } from "react-redux-i18n";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const CustomControlPanel = () => {
  const slider = useRef<Slider>(null);
  const nextSlide = () => {
    slider?.current?.slickNext();
  };
  const prevSlide = () => {
    slider?.current?.slickPrev();
  };
  return (
    <div className="w-full flex justify-center pt-[88px] bg-[#171c29]">
      <div className="container max-w-[1280px]">
      <div className="px-3">
          <h2 className="uppercase text-[36px] font-[900] pb-[6px] text-center lg:mt-8 text-white">
          {I18n.t("customControlPanel")}
          </h2>
          <p className="pb-[20px] text-center">
          {I18n.t("edit_files_with_ease")}
          </p>
        </div>
        <div className="max-w-[800px] mx-auto px-4 relative mb-20">
          <Slider adaptiveHeight={true} ref={slider} arrows={false}>
            <div className="w-full">
              <img
                className="mx-auto"
                src="/fragify-dashboard.png"
                alt="dashboard"
              />
            </div>
            <div className="w-full">
              <img
                className="mx-auto"
                src="/fragify-modpacks.png"
                alt="modpacks"
              />
            </div>
            <div className="w-full">
              <img className="mx-auto" src="/fragify-editor.png" alt="editor" />
            </div>
          </Slider>
          <div
            className="absolute top-0 right-20 h-full items-center flex text-[25px] hover:text-white"
            onClick={nextSlide}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
          <div
            className="absolute top-0 left-20 h-full items-center flex text-[25px] hover:text-white"
            onClick={prevSlide}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomControlPanel;
